import React, { useContext, useEffect, useState } from 'react'
import Select from 'react-select';
import { FaCheck, FaCheckCircle, FaRegCircle } from "react-icons/fa";
import { Context } from '../Context/Context';
import { IoArrowDownSharp } from "react-icons/io5";
import AcctDetailsBar from './AcctDetailsBar';
import ConvertCurrency from './ConvertCurrency';
import SendBar from './SendBar';
import LiveRates from './LiveRates';
import Search from '../Components/Images/search-lg.svg'
import Copy from '../Components/Images/Copy2.svg'
// import Bell from '../Components/Images/bell-01.svg'
import Add from '../Components/Images/AddBtn.svg'
import Warn from '../Components/Images/info-circle.svg'
import arrow from '../Components/Images/arrowUp.svg'
// import switchs from '../Components/Images/switch-horizontal-01.svg'
import Bank from '../Components/Images/bank.svg'
import refresh from '../Components/Images/refresh.svg'
import GreenLine from '../Components/Images/greenLine.png'
import RedLine from '../Components/Images/redLine.png'
// import Increase from '../Components/Images/Increase.svg'
import ViewTransactionDetailsBar from './ViewTransactionDetailsBar';
import CreateAcctBar from './CreateAcctBar';
import { useNavigate } from 'react-router-dom';
import { GoDotFill } from 'react-icons/go';
import { FiEye, FiEyeOff } from 'react-icons/fi';
// import countries from './Countries';

function filterPaymentsByDate(payments, filterType) {
    const now = new Date();

    return payments.filter(payment => {
        const paymentDate = new Date(payment.date_created);

        switch (filterType) {
            case 'total':
                return true; // return all payments
            case 'lastWeek': {
                const oneWeekAgo = new Date(now);
                oneWeekAgo.setDate(now.getDate() - 7);
                return paymentDate >= oneWeekAgo && paymentDate <= now;
            }
            case '3daysAgo': {
                const threeDaysAgo = new Date(now);
                threeDaysAgo.setDate(now.getDate() - 3);
                return paymentDate >= threeDaysAgo && paymentDate <= now;
            }
            case '5daysAgo': {
                const fiveDaysAgo = new Date(now);
                fiveDaysAgo.setDate(now.getDate() - 5);
                return paymentDate >= fiveDaysAgo && paymentDate <= now;
            }
            case 'lastMonth': {
                const startOfThisMonth = new Date(now.getFullYear(), now.getMonth(), 1);
                const startOfLastMonth = new Date(startOfThisMonth);
                startOfLastMonth.setMonth(startOfThisMonth.getMonth() - 1);
                const endOfLastMonth = new Date(startOfThisMonth);
                endOfLastMonth.setDate(0); // last day of previous month
                return paymentDate >= startOfLastMonth && paymentDate <= endOfLastMonth;
            }
            default:
                return false;
        }
    });
}


const Overview = ({ NumberOfUserAcct, NumberOfBeneficiaryAcct, NumberOfInvoices, UserProfile, setSendErrorBar, setOpenSendBar }) => {

    const Spinner = () => (
        <div className="w-6 h-6 border-4 my-4 border-t-transparent border-[#542d9d] rounded-full animate-spin"></div>
    );

    const navigate = useNavigate()



    const {
        handleAcctDetailsBar,
        acctDetailsBar,
        handleSendBar,
        sendBar,
        handleConvertBar,
        convertBar,
        handleLiveRates,
        liveRatesBar,
        setSelectedTransactionDetails,
        handleOverViewTransactionDetails,
        overViewTransactionDetails,
        handleAcctBar,
        acctBar,
        handleViewDetails,
        viewDetails,
        loading,
        currencyLogos,
        fetchAccountsAndWalletData
    } = useContext(Context)

    const walletBalance = JSON.parse(localStorage.getItem('WalletBalance'))
    const accounts = JSON.parse(localStorage.getItem('UserAcctDetails'))
    const transactions = JSON.parse(localStorage.getItem('UserTransactions'))
    const sentAmount = JSON.parse(localStorage.getItem('UserPayments'))

    const [showBalance, setShowBalance] = useState(JSON.parse(localStorage.getItem('showBalance')));
    const [selectedCurrency, setSelectedCurrency] = useState('');
    const [selectedAccount, setSelectedAccount] = useState('');

    const [isSmScreen, setIsSmScreen] = useState(window.innerWidth < 640);

    useEffect(() => {
        const handleResize = () => {
            setIsSmScreen(window.innerWidth < 640);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const handleCreateAcct = () => {
        if (NumberOfUserAcct >= 2) {
            handleSendBar();
        } else {
            handleAcctBar();
        }
    };

    const handleShowBalance = () => {
        const newValue = !showBalance;
        setShowBalance(newValue);
        localStorage.setItem('showBalance', JSON.stringify(newValue));
    };

    const option1 = [
        {
            value: '',
            label: (
                <p className='text-[14px]'>This week</p>
            )
        }
    ]
    const option2 = [
        { value: 'total', label: <p className='text-[14px]'>Total</p> },
        { value: 'lastWeek', label: <p className='text-[14px]'>Last week</p> },
        { value: '3daysAgo', label: <p className='text-[14px]'>3 days ago</p> },
        { value: '5daysAgo', label: <p className='text-[14px]'>5 days ago</p> },
        { value: 'lastMonth', label: <p className='text-[14px]'>Last month</p> }
    ];

    const [filteredPayments, setFilteredPayments] = useState([])
    const [selectedMoneyRecieved, setSelectedMoneyRecieved] = useState(null);
    const [selectedMoneySent, setSelectedMoneySent] = useState(option2[0]);

    const roundUp = (value, decimals = 2) => {
        const factor = Math.pow(10, decimals);
        return Math.ceil(value * factor) / factor;
    };

    const [output, setOutput] = useState("");
    // const [status, setStatus] = useState('');

    useEffect(() => {
        const saved = JSON.parse(localStorage.getItem('selectedCurrency'));
        if (saved?.value) {
            setSelectedCurrency(saved.value);
        } else if (accounts?.length > 0) {
            setSelectedCurrency(accounts[0].currency);
        }
    }, [accounts]);

    // Sync account when currency changes
    useEffect(() => {
        if (selectedCurrency) {
            const acct = accounts.find((a) => a.currency === selectedCurrency);
            // Compare by currency or id, not object reference
            if (acct && (!selectedAccount || acct.currency !== selectedAccount.currency)) {
                setSelectedAccount(acct);
            }
        }
    }, [selectedCurrency, accounts, selectedAccount]);



    useEffect(() => {
        if (selectedMoneySent && Array.isArray(sentAmount)) {
            const filtered = filterPaymentsByDate(sentAmount, selectedMoneySent.value);

            // Compare stringified versions to avoid unnecessary state updates
            if (JSON.stringify(filtered) !== JSON.stringify(filteredPayments)) {
                setFilteredPayments(filtered);
            }
        } else if (filteredPayments?.length !== 0) {
            setFilteredPayments([]);
        }
    }, [selectedMoneySent, sentAmount, filteredPayments]);


    useEffect(() => {
        if (selectedCurrency === 'USD') {
            setOutput("USD");
        } else if (selectedCurrency === 'EUR') {
            setOutput("EUR");
        } else {
            setOutput("");
        }
    }, [selectedCurrency]);

    const [searchQuery, setSearchQuery] = useState('');
    const handleSearch = (query) => {
        setSearchQuery(query);
    };

    const currencyOptions = accounts.map((account) => ({
        value: account.currency, // string
        label: (
            <div className="flex items-center gap-2">
                <img
                    src={currencyLogos[account.currency]}
                    alt={account.currency}
                    className="w-[20px] h-4"
                />
                <span>{account.currency}</span>
            </div>
        ),
    }));

    const handleTransactionClick = (id) => {
        localStorage.setItem('invoiceID', id);
    };

    const customStyles = {
        indicatorSeparator: () => ({
            display: 'none',
        }),
        control: (base) => ({
            ...base,
            borderColor: '#F3F0F7',
            borderWidth: '1.2px',
            boxShadow: '0 1px 2px 0 #1D1C1F0D',
            borderRadius: '10px',
            width: '120px',
        }),
        menu: (base) => ({
            ...base,
            zIndex: 999,
        }),
        dropdownIndicator: (provided) => ({
            ...provided,
            padding: '0 4px', // adjust this value to reduce the space
        }),
        option: (base, state) => ({
            ...base,
            backgroundColor: state.isFocused ? '#F3F0F7' : 'white',
            color: 'black',
            cursor: 'pointer',
        }),
    }

    const customStyles2 = {
        indicatorSeparator: () => ({
            display: 'none',
        }),
        control: (base) => ({
            ...base,
            borderColor: '#F3F0F7',
            borderWidth: '1.2px',
            boxShadow: '0 1px 2px 0 #1D1C1F0D',
            borderRadius: '10px',
            width: '120px',
        }),
        menu: (base) => ({
            ...base,
            zIndex: 999,
        }),
        dropdownIndicator: (provided) => ({
            ...provided,
            padding: '0 4px', // adjust this value to reduce the space
        }),
        option: (base, state) => ({
            ...base,
            backgroundColor: state.isFocused ? '#F3F0F7' : 'white',
            color: 'black',
            cursor: 'pointer',
        }),
    }

    const handleChange2 = (selectedOption) => {
        setSelectedMoneyRecieved(selectedOption);
    }
    const handleChange3 = (selectedOption) => {
        setSelectedMoneySent(selectedOption);
    }

    const filteredTransactions = searchQuery
        ? transactions.filter(transact => {
            const formattedDate = new Date(transact.date_created).toLocaleDateString("en-GB", {
                day: '2-digit',
                month: 'short',
                year: 'numeric',
            }).toLowerCase();

            const query = searchQuery.toLowerCase();

            return (
                formattedDate.includes(query) ||
                (transact.type?.toLowerCase() || '').includes(query) ||
                (transact.amount?.toString().toLowerCase() || '').includes(query) ||
                (transact.payment?.beneficiary?.full_name?.toLowerCase() || '').includes(query) ||
                (transact.currency?.toLowerCase() || '').includes(query) ||
                (transact.payment?.status?.toLowerCase() || '').includes(query)
            );
        })
        : transactions;

    const [copied, setCopied] = useState(false)

    const handleCopy = async () => {
        const textToCopy = UserProfile.circle_wallet_address;

        try {
            await navigator.clipboard.writeText(textToCopy);
            setCopied(true);

            setTimeout(() => setCopied(false), 1000);
        } catch (err) {
            console.error('Failed to copy:', err);
        }
    };

    return (
        <div>
            <div
                className={`w-full top-0 h-[500%] absolute z-20 ${viewDetails || acctDetailsBar || sendBar || convertBar || liveRatesBar || overViewTransactionDetails || acctBar ? 'bg-black/20' : 'hidden'}`}
                onClick={viewDetails ? handleViewDetails : acctDetailsBar ? handleAcctDetailsBar : convertBar ? handleConvertBar : sendBar ? handleSendBar : liveRatesBar ? handleLiveRates : overViewTransactionDetails ? handleOverViewTransactionDetails : acctBar ? handleAcctBar : null}
            ></div>
            <div className='text-[#1D1C1F] md:p-10 px-4 py-10'>
                <div className='flex items-center justify-between'>
                    <div className='flex items-center gap-2'>
                        <p className='text-[28px] font-semibold'>Home</p>
                    </div>

                    <div className='flex md:items-center items-start gap-8'>
                        <img
                            src={refresh}
                            alt=""
                            onClick={fetchAccountsAndWalletData}
                            className='cursor-pointer'
                        />
                        <div
                            onClick={handleCopy}
                            className='w-[240px] sh:flex hidden items-center text-[14px] p-[2px] rounded-[10px] bg-gradient-to-r from-[#B089F5] via-[#E1A5E9] via-[#A470FF] via-[#B630C74D] to-[#B391EE] text-[#531CB3]'
                        >
                            <div className='bg-white flex items-center justify-between rounded-lg px-3 py-2 w-full'>
                                <p className='truncate w-[175px]'>USDC address: {UserProfile.circle_wallet_address}</p>
                                {copied ? (
                                    <FaCheck className='text-[20px] text-[#531CB3]' />
                                ) : (
                                    <img className='cursor-pointer w-[20px] h-[20px]' src={Copy} alt='Copy' />
                                )}
                            </div>
                        </div>
                        {/* <img className='lg:block hidden cursor-pointer' src={Search} alt='Search' /> */}
                        {/* <img className='lg:block hidden cursor-pointer' src={Bell} alt='Notifications' /> */}
                        <img onClick={handleCreateAcct} className='w-10 cursor-pointer' src={Add} alt='Add Account' />
                    </div>
                </div>

                <p className='text-[16px] font-normal text-[#525154]'>
                    Welcome back, <span>{UserProfile.first_name}!</span>
                </p>

                <div
                    onClick={handleCopy}
                    className='w-[240px] flex sh:hidden mt-3 items-center text-[14px] p-[2px] rounded-lg bg-gradient-to-r from-[#B089F5] via-[#E1A5E9] via-[#A470FF] via-[#B630C74D] to-[#B391EE] text-[#531CB3]'
                >
                    <div className='bg-white flex items-center justify-between rounded-lg px-3 py-2 w-full'>
                        <p className='truncate w-[175px]'>USDC address: {UserProfile.circle_wallet_address}</p>
                        {copied ? (
                            <FaCheck className='text-[20px] text-black' />
                        ) : (
                            <img className='cursor-pointer w-[20px] h-[20px]' src={Copy} alt='Copy' />
                        )}
                    </div>
                </div>
            </div>
            <div className='flex justify-between items-center md:px-10 px-4 py-2'>
                <p className='font-medium text-[18px]'>Overview</p>
            </div>
            <div className='md:px-10 px-4 pt-4 flex md:flex-row flex-col md:gap-0 gap-7'>
                <div className='w-full md:border-r-[1.3px] md:pr-4 border-[#E6E4EB]'>
                    <div className='flex items-center justify-between'>
                        <p className='flex items-center gap-1 text-[14px] text-[#78757A]'>
                            Total balance <img src={Warn} alt="" />
                        </p>
                    </div>
                    <div className='text-[36px] mt-2 font-semibold flex items-center'>
                        {loading ? (
                            <Spinner />
                        ) : (
                            <div className='flex justify-between items-center w-full'>
                                {showBalance ? (
                                    <p onClick={handleShowBalance} className='cursor-pointer'>
                                        ${roundUp(walletBalance.balance, 1)}
                                    </p>
                                ) : (
                                    <p className='text-[24px] font-normal py-[9px]'>*****</p>
                                )}
                                {showBalance ? (
                                    <div onClick={handleShowBalance} className='cursor-pointer flex items-center gap-1'>
                                        <FiEyeOff className='text-[24px] text-[#531CB3]' />
                                        {/* <p className='text-[14px] text-[#531CB3] font-medium'>Hide balance</p> */}
                                    </div>
                                ) : (
                                    <div onClick={handleShowBalance} className='cursor-pointer flex items-center gap-1'>
                                        <FiEye className='text-[24px] text-[#531CB3]' />
                                        {/* <p className='text-[14px] text-[#531CB3] font-medium'>Show balance</p> */}
                                    </div>
                                )}
                            </div>
                        )}
                    </div>
                    {/* <p className='bg-[#DFFEEA] border-[1.5px] border-[#009937] text-[#009937] font-medium w-20 py-1 rounded-md text-center flex justify-center items-center gap-1'>
                        +25% <img src={Increase} className='size-[16px]' alt='Increase' />
                    </p> */}
                    <div className='flex md:gap-1 gap-4 w-full mt-5 items-center text-[#78757A]'>
                        {[{ icon: Bank, label: 'Details', onClick: handleAcctDetailsBar },  { icon: arrow, label: 'Send', onClick: handleSendBar }].map(({ icon, label, onClick }) => (
                            <div
                                key={label}
                                className='border border-[#E6E4EB] py-2 rounded-md w-full flex items-center justify-center gap-1 cursor-pointer text-[13px] text-[#525154] font-medium hover:bg-black/10 active:scale-95 transition-all duration-500'
                                onClick={onClick}
                            >
                                <img className='w-[20px]' src={icon} alt={label} />
                                <p className='font-semibold'>{label}</p>
                            </div>
                        ))}

                        {/* { icon: switchs, label: 'Convert', onClick: handleConvertBar }, */}
                    </div>
                </div>
                <div className='w-full md:ml-5 md:border-r-[1.3px] md:pr-4 border-[#E6E4EB]'>
                    <div className='flex items-center justify-between'>
                        <p className='flex items-center gap-1 text-[14px] text-[#78757A]'>Total money recieved</p>
                        <Select
                            styles={customStyles}
                            options={option1}
                            onChange={handleChange2}
                            value={selectedMoneyRecieved}
                            isSearchable={false}
                        />
                    </div>
                    <div>
                        <div className='text-[36px] font-semibold flex items-center'>
                            {loading ? (
                                <Spinner />
                            ) : (
                                <div className='flex justify-between items-center w-full'>
                                    {showBalance ? (
                                        <p className='text-[36px] font-semibold'>$0</p>
                                    ) : (
                                        <p className='text-[24px] font-normal py-[9px]'>*****</p>
                                    )}
                                </div>
                            )}
                        </div>
                        <img className='ml-3 md:w-full w-[70%] xl:w-[50%]' src={GreenLine} alt="" />
                    </div>
                </div>
                <div className='w-full md:ml-5'>
                    <div className='flex items-center justify-between'>
                        <p className='flex items-center gap-1 text-[14px] text-[#78757A]'>
                            Total money sent
                        </p>
                        <Select
                            styles={customStyles2}
                            options={option2}
                            onChange={handleChange3}
                            value={selectedMoneySent}
                            isSearchable={false}
                        />
                    </div>
                    <div>
                        <div className='text-[36px] flex font-semibold items-center'>
                            {loading ? (
                                <Spinner />
                            ) : (
                                <>
                                    <div className='flex justify-between items-center w-full'>
                                        {showBalance ? (
                                            <p onClick={handleShowBalance} className='cursor-pointer'>
                                                ${filteredPayments?.length === 0
                                                    ? 0
                                                    : filteredPayments.reduce((sum, p) => sum + Number(p.amount), 0)}
                                            </p>
                                        ) : (
                                            <p className='text-[24px] font-normal py-[9px]'>*****</p>
                                        )}
                                    </div>
                                </>
                            )}
                        </div>
                        <img className='md:w-full w-[70%] xl:w-[50%]' src={RedLine} alt="" />
                    </div>
                </div>
            </div>
            {(NumberOfUserAcct === 0 || NumberOfInvoices === 0 || NumberOfInvoices === 0 || transactions?.length === 0) && (
                <div className='mt-[45px] md:mx-10 mx-4'>
                    <h1 className='font-medium text-[18px]'>Congratulations on taking the first step!</h1>
                    <p className='text-[14px] font-normal text-[#525154]'>Complete these simple steps to get started using reccur.</p>
                    <div className='flex sm:flex-row flex-col text-[14px] justify-between gap-4 w-[80%] 2xl:w-[50%] 3xl:w-[20%] mt-4'>
                        <div className='flex flex-col gap-4'>
                            <div
                                className={`flex items-center gap-2 cursor-pointer ${NumberOfUserAcct > 0 ? 'text-black/50 line-through' : 'text-[#542d9d] underline'}`}
                                onClick={() => {
                                    if (NumberOfUserAcct === 0) {
                                        handleAcctBar()
                                    }
                                }}
                            >
                                {NumberOfUserAcct > 0 ? (
                                    <FaCheckCircle className='mt-1 text-[#542d9d]' />
                                ) : (
                                    <FaRegCircle className='mt-1 text-black/50' />
                                )}
                                <p>Create your first bank account</p>
                            </div>
                            <div
                                className={`flex items-center gap-2 cursor-pointer ${NumberOfInvoices > 0 ? 'text-black/50 line-through' : 'text-[#542d9d] underline'}`}
                                onClick={() => {
                                    if (NumberOfInvoices === 0) {
                                        navigate('/invoices');
                                    }
                                }}
                            >
                                {NumberOfInvoices > 0 ? (
                                    <FaCheckCircle className='mt-1 text-[#542d9d]' />
                                ) : (
                                    <FaRegCircle className='mt-1 text-black/50' />
                                )}
                                <p>Create your first invoice</p>
                            </div>
                        </div>
                        <div className='flex flex-col gap-4'>
                            <div
                                className={`flex items-center gap-2 cursor-pointer ${NumberOfBeneficiaryAcct > 0 ? 'text-black/50 line-through' : 'text-[#542d9d] underline'}`}
                                onClick={() => {
                                    if (NumberOfBeneficiaryAcct === 0) {
                                        navigate('/beneficiaries');
                                    }
                                }}
                            >
                                {NumberOfBeneficiaryAcct > 0 ? (
                                    <FaCheckCircle className='mt-1 text-[#542d9d]' />
                                ) : (
                                    <FaRegCircle className='mt-1 text-black/50' />
                                )}
                                <p>Add your first beneficiary</p>
                            </div>
                            <div
                                className={`flex items-center gap-2 cursor-pointer ${transactions?.length > 0 ? 'text-black/50 line-through' : 'text-[#542d9d] underline'}`}
                                onClick={() => {
                                    if (transactions?.length === 0) {
                                        handleAcctBar()
                                    }
                                }}
                            >
                                {transactions?.length > 0 ? (
                                    <FaCheckCircle className='mt-1 text-[#542d9d]' />
                                ) : (
                                    <FaRegCircle className='mt-1 text-black/50' />
                                )}
                                <p>Make your first withdrawal</p>
                            </div>
                        </div>
                    </div>
                </div>
            )}
            <div className='mt-[30px] md:px-10 px-4 pb-8 text-black/70'>
                <div className='mh:flex items-center justify-between'>
                    <div className='mb-5 mh:mb-0'>
                        <p className='text-[18px] font-medium'>Transactions</p>
                        <p className='text-[14px] font-normal text-[#525154]'>Track and manage all your payments, transfers, and conversions in one place.</p>
                    </div>
                    <a href='/transactions'>
                        <span className='mt-4 bg-white px-4 py-[10px] text-[14px] border border-[#E6E4EB] rounded-lg'>
                            All Transactions
                        </span>
                    </a>

                </div>
                <div className='mt-[30px]'>
                    <div className='relative'>
                        <input
                            type="text"
                            placeholder="Search invoices by number, items, clients or amount"
                            value={searchQuery}
                            onChange={(e) => handleSearch(e.target.value)}
                            className="px-4 py-2 border-none outline-none border-gray-300 w-full placeholder:text-[#667085] placeholder:text-[14px] ml-5 rounded-md"
                        />
                        <img src={Search} alt="" className='absolute top-2' />
                    </div>
                    <div className='mt-[15px] '>
                        <div className='sm:grid md:grid-cols-9 sm:grid-cols-8 sp:grid-cols-7 flex justify-between items-center gap-5 border-t border-b text-[#667085] border-[#EAECF0] py-[14px] px-4 text-[14px] font-normal text-left'>
                            <div className='sm:flex hidden gap-2 col-span-2 items-center min-w-0'>
                                <p className='truncate'>Payment date</p>
                                <IoArrowDownSharp className='mt-1 text-[16px]' />
                            </div>
                            <div className='sm:flex hidden gap-2 items-center min-w-0'>
                                <p className='truncate'>Type</p>
                                <IoArrowDownSharp className='mt-1 text-[16px]' />
                            </div>
                            <div className='sm:flex hidden items-center justify-end min-w-0'>
                                <p className='truncate'>Amount</p>
                            </div>
                            <div className='min-w-0 sm:block hidden'>
                                <p className='truncate flex justify-center'>Currency</p>
                            </div>
                            <div className='items-center col-span-2 min-w-0'>
                                <p className='truncate'>Sender/Recipient</p>
                            </div>
                            {/* <div className='min-w-0 block sm:hidden'>
                                <p className='truncate'>Currency</p>
                            </div> */}
                            <div className='flex sm:hidden items-center justify-end min-w-0'>
                                <p className='truncate'>Amount</p>
                            </div>
                            <div className='md:flex hidden items-center min-w-0'>
                                <p className='truncate'>Status</p>
                            </div>
                            <div className='sm:flex hidden items-center min-w-0 invisible'>
                                <p className='truncate'>Details</p>
                            </div>
                        </div>
                        {loading ? (
                            <div className="flex justify-center items-center h-[20vh]">
                                <p className="text-lg font-medium text-[#531CB3]">Loading transactions...</p>
                            </div>
                        ) : (
                            <>
                                {filteredTransactions?.map((transact, index) => (
                                    <div
                                        onClick={isSmScreen ? () => {
                                            setSelectedTransactionDetails(transact)
                                            handleOverViewTransactionDetails()
                                            handleTransactionClick(transact.id)
                                        }
                                            : undefined}
                                        key={index} className='sm:grid md:grid-cols-9 sm:cursor-auto cursor-pointer sm:hover:bg-white hover:bg-[#F3F0F7] sm:grid-cols-8 sp:grid-cols-7 flex justify-between gap-5 border-b border-[#EAECF0] py-[14px] px-4 text-[14px] text-[#344054] text-left items-center'>
                                        <div className='min-w-0 sm:block hidden col-span-2'>
                                            <p className='truncate'>
                                                {new Date(transact.date_created).toLocaleDateString("en-GB", {
                                                    day: '2-digit',
                                                    month: 'short',
                                                    year: 'numeric',
                                                })}
                                            </p>
                                        </div>

                                        <div className='min-w-0 sm:flex hidden'>
                                            <p className='truncate'>{transact.type.charAt(0).toUpperCase() + transact.type.slice(1)}</p>
                                        </div>

                                        <div className={`min-w-0 sm:block hidden text-right`}>
                                            {showBalance ? (
                                                <p className='truncate text-[14px]'>
                                                    {/* {transact.currency === 'USD' ? '$' : '€'} */}
                                                    ${transact.amount}
                                                </p>
                                            ) : (
                                                <p>***</p>
                                            )}

                                        </div>

                                        <div className='min-w-0 sm:flex hidden gap-1 items-center justify-center'>
                                            {transact.payment.beneficiary.currency ? (
                                                <div className='flex gap-1 items-center'>
                                                    <img
                                                        src={currencyLogos[transact.payment.beneficiary.currency]}
                                                        alt={transact.currency}
                                                        className="w-[20px] h-4 rounded-sm"
                                                    />
                                                    {transact.payment.beneficiary.currency}
                                                </div>
                                            ) : transact.payment.beneficiary.cryptocurrency_type ? (
                                                <div>
                                                    {transact.payment.beneficiary.cryptocurrency_type}
                                                </div>
                                            ) : (
                                                <p>—</p>
                                            )}
                                        </div>

                                        <div className='min-w-0 col-span-2'>
                                            <p className='truncate'>{transact.payment.beneficiary.full_name}</p>
                                            <div className=' flex sm:hidden items-center gap-[2px] text-[12px] text-black/50'>
                                                <p>
                                                    {new Date(transact.date_created).toLocaleTimeString([], {
                                                        hour: '2-digit',
                                                        minute: '2-digit',
                                                    })}
                                                </p>
                                                <GoDotFill className='text-black text-[8px]' />
                                                {new Date(transact.date_created).toLocaleDateString("en-GB", {
                                                    day: '2-digit',
                                                    month: 'short',
                                                    year: 'numeric',
                                                })}
                                            </div>
                                        </div>

                                        {/* <div className='min-w-0 flex sm:hidden gap-1 items-center'>
                                            <img
                                                src={currencyLogos[transact.currency]}
                                                alt={transact.currency}
                                                className="w-[20px] h-4 rounded-md"
                                            />
                                            {transact.currency}
                                        </div> */}

                                        <div className={`min-w-0 sm:hidden font-bold text-right ${showBalance ? 'block' : 'hidden'}`}>
                                            <div className={`truncate text-[14px] rounded-full p-[1.4px] flex items-center gap-[1px]
                                                                  ${transact.type === 'credit' && 'text-[#027A48]'}
                                                                  ${(transact.type === 'credit' || transact.type === 'debit') && transact.payment.status === 'pending' && 'text-[#B54708]'}
                                                                  ${transact.type === 'debit' && 'text-red-600'}
                                                        `}>
                                                {transact.type !== 'debit' ? <p className='sm:hidden block'>+</p> : <p className='sm:hidden block'>-</p>}
                                                {/* {transact.currency === 'USD' ? '$' : '€'} */}
                                                ${transact.amount}
                                            </div>
                                        </div>

                                        <div className='min-w-0 md:block hidden'>
                                            <div
                                                className={`rounded-xl py-[2px] px-2 flex items-center justify-center w-fit truncate
                                                                  ${transact.payment.status === 'completed' && 'bg-[#ECFDF3] text-[#027A48]'}
                                                                  ${transact.payment.status === 'pending' && 'bg-[#FFFAEB] text-[#B54708]'}
                                                                  ${transact.payment.status === 'failed' && 'bg-red-100 text-red-600'}
                                                        `}
                                            >
                                                {transact.payment.status}
                                            </div>
                                        </div>

                                        <div className='min-w-0 sm:flex hidden'>
                                            <button
                                                className='text-[#542d9d] truncate'
                                                onClick={() => {
                                                    setSelectedTransactionDetails(transact)
                                                    handleOverViewTransactionDetails()
                                                    handleTransactionClick(transact.id)
                                                }}
                                            >
                                                View Details
                                            </button>
                                        </div>
                                    </div>
                                ))}
                                <div className='my-4 text-[#344054]'>
                                    {filteredTransactions?.length} {filteredTransactions?.length > 1 ? 'items' : 'item'}
                                </div>
                            </>
                        )}
                    </div>
                </div>
            </div>
            <AcctDetailsBar
                selectedCurrency={selectedCurrency}
                currencyOptions={currencyOptions}
                output={output}
                setSelectedCurrency={setSelectedCurrency}
                UserAcctDetails={accounts}
                roundUp={roundUp}
                currencyLogos={currencyLogos}
                selectedAccount={selectedAccount}
                balance={walletBalance}
            />
            <ConvertCurrency />
            <SendBar setSendErrorBar={setSendErrorBar} setOpenSendBar={setOpenSendBar} />
            <CreateAcctBar />
            <LiveRates />
            {
                overViewTransactionDetails && (
                    <ViewTransactionDetailsBar className='duration-700 transition-all' />
                )
            }
        </div >
    )
}

export default Overview